<h2 *ngIf="dataSourceAd && dataSourceSite">
  <div class="ml-20 display-flex flex-align-center">
    <app-source [item]="dataSourceSite"></app-source>
    <mat-icon class="breadcrumb-separator">chevron_right</mat-icon>
    <app-source [item]="dataSourceAd"></app-source>
  </div>
</h2>
